export enum DatadogEnv {
	LOCAL = "local",
	DEV = "dev",
	PROD = "prod",
}
